const initialState = {
    scope: {},
    updating: false,
    updated: false,
    error: null,

    tabs: [],
    updatingTabs: false,
    updatedTabs: false,
    errorTabs: null,

    tabid: null,
    tabndx: -1,

    questionndx: -1,
    optionndx: -1,

    updatingQuestions: false,
    updatedQuestions: false,
    errorQuestions: null
}

export function scopeReducer(state = initialState, action) {

    switch (action.type) {

        // scopes
        case "CREATE_SCOPE":
        case "DELETE_SCOPE":
        case "FETCH_SCOPE":
        case "UPDATE_SCOPE": {
            return { ...state, updating: true, updated: false, error: null }
        }

        case "CREATE_SCOPE_REJECTED":
        case "DELETE_SCOPE_REJECTED":
        case "FETCH_SCOPE_REJECTED":
        case "UPDATE_SCOPE_REJECTED": {
            return { ...state, updating: false, error: action.payload }
        }

        case "CREATE_SCOPE_FULFILLED":
        case "FETCH_SCOPE_FULFILLED":
        case "UPDATE_SCOPE_FULFILLED": {
            return { ...state, updating: false, updated: true, scope: action.payload.data }
        }

        case "DELETE_SCOPE_FULFILLED": {
            return { ...state, updating: false, updated: true }
        }

        case "SCOPE_ERROR": {
            return { ...state, error: null }
        }

        // tabs
        case "UPDATE_SCOPE_TAB":
        case "DELETE_SCOPE_TAB":
        case "UPDATE_SCOPE_TABS":
        case "FETCH_SCOPE_TABS_LIST": {
            return {
                ...state,
                updatingTabs: true,
                updatedTabs: false,
                errorTabs: null,
                tabid: null,
                tabndx: -1,
                updatingQuestions: false,
                updatedQuestions: false,
                errorQuestions: null
            }
        }

        case "UPDATE_SCOPE_TAB_QUESTION":
        case "UPDATE_SCOPE_TAB_QUESTION_OPTION":
        case "UPDATE_SCOPE_TAB_QUESTION_DETAIL_OPTION": {
            return { ...state, updatingQuestions: true, updatedQuestions: false, errorQuestions: null }
        }

        case "DELETE_SCOPE_TAB_QUESTION_REJECTED":
        case "UPDATE_SCOPE_TAB_REJECTED":
        case "DELETE_SCOPE_TAB_REJECTED":
        case "UPDATE_SCOPE_TABS_REJECTED":
        case "FETCH_SCOPE_TABS_LIST_REJECTED": {
            return { ...state, updatingTabs: false, errorTabs: action.payload }
        }

        case "UPDATE_SCOPE_TAB_FULFILLED": {
            var ndx = 0
            var foundndx = -1

            var curtabs = Object.assign([], state.tabs)

            curtabs.forEach((tab) => {
                if (tab.projectTabId == action.payload.data.projectTabId) 
                    foundndx = ndx
                else
                    ndx++
            })

            curtabs[foundndx] = action.payload.data

            curtabs.sort((a, b) => {
                if (a.order > b.order)
                    return 1
                else if (a.order < b.order)
                    return -1
                else
                    return 0
            })

            return { ...state, updatingTabs: false, updatedTabs: true, tabs: curtabs }
        }

        case "UPDATE_SCOPE_TABS_FULFILLED": {
            var curtabs = Object.assign([], state.tabs)

            curtabs.push(action.payload.data)

            curtabs.sort((a, b) => {
                if (a.order > b.order)
                    return 1
                else if (a.order < b.order)
                    return -1
                else
                    return 0
            })

            return { ...state, updatingTabs: false, updatedTabs: true, tabs: curtabs }
        } 

        case "DELETE_SCOPE_TAB_FULFILLED": {
            return { ...state, updatingTabs: false, updatedTabs: true }
        }

        case "FETCH_SCOPE_TABS_LIST_FULFILLED": {
            action.payload.data.forEach((tab) => {
                tab["questions"] = []
            })

            action.payload.data.sort((a, b) => {
                if (a.order > b.order)
                    return 1
                else if (a.order < b.order)
                    return -1
                else
                    return 0
            })

            return { ...state, updatingTabs: false, updatedTabs: true, tabs: action.payload.data }
        }

        case "FETCH_SCOPE_TABS_ERROR":
        case "SCOPE_TABS_ERROR": {
            return { ...state, errorTabs: null }
        }

        // questions
        case "DELETE_SCOPE_TAB_QUESTION": {
            return { ...state, updatingQuestions: true, updatedQuestions: false, errorQuestions: null }
        }

        case "UPDATE_SCOPE_TAB_QUESTION_DETAIL": {
            return { ...state, updatingQuestions: true, updatedQuestions: false, questionndx: action.payload.data }
        }

        case "FETCH_SCOPE_TAB_QUESTIONS_LIST": {
            var curtabs = Object.assign([], state.tabs)

            curtabs[action.payload.data.ndx]["rcvOptQuestions"] = 0

            return {
                ...state,
                tabid: action.payload.data.id,
                tabndx: action.payload.data.ndx,
                updatingQuestions: true,
                updatedQuestions: false,
                errorQuestions: null,
                updatedQuestionsOptions: false,
                tabs: curtabs
            }
        }

        case "UPDATE_SCOPE_TAB_QUESTION_DETAIL_REJECTED":
        case "UPDATE_SCOPE_TAB_QUESTION_REJECTED": 
        case "UPDATE_SCOPE_TAB_QUESTION_OPTION_REJECTED":
        case "UPDATE_SCOPE_TAB_QUESTION_DETAIL_OPTION_REJECTED":
        case "FETCH_SCOPE_TAB_QUESTIONS_LIST_REJECTED": {
            return { ...state, updatingQuestions: false, errorQuestions: action.payload }
        }

        case "DELETE_SCOPE_TAB_QUESTION_FULFILLED": {
            var ndx = 0
            var foundndx = -1

            var curtabs = Object.assign([], state.tabs)

            curtabs[state.tabndx].questions.forEach((quest) => {
                if (quest.questionID == action.payload.data.questionID)
                    foundndx = ndx
                else
                    ndx++
            })

            curtabs[state.tabndx].questions.splice(foundndx, 1)

            return { ...state, updatingQuestions: false, updatedQuestions: true, tabs: curtabs }
        }

        case "UPDATE_SCOPE_TAB_QUESTION_DETAIL_FULFILLED": {
            var curtabs = Object.assign([], state.tabs)

            curtabs[state.tabndx].questions[state.questionndx] = action.payload.data

            return { ...state, updatingQuestions: false, updatedQuestions: true, tabs: curtabs }
        }

        case "UPDATE_SCOPE_TAB_QUESTION_FULFILLED": {

            var ndx = 0
            var foundndx = -1

            var curtabs = Object.assign([], state.tabs)

            curtabs[state.tabndx].questions.forEach((quest) => {
                if (quest.questionID == action.payload.data.questionID)
                    foundndx = ndx
                else
                    ndx++
            })

            if (foundndx != -1)
                curtabs[state.tabndx].questions[foundndx] = action.payload.data
            else
                curtabs[state.tabndx].questions.push(action.payload.data)

            return { ...state, updatingQuestions: false, updatedQuestions: true, tabs: curtabs }
        }

        case "UPDATE_SCOPE_TAB_QUESTION_OPTION_FULFILLED":
        case "UPDATE_SCOPE_TAB_QUESTION_DETAIL_OPTION_FULFILLED": {
            var ndx = 0
            var foundndx = -1
            var foundndx2 = -1

            var curtabs = Object.assign([], state.tabs)

            curtabs[state.tabndx].questions.forEach((quest) => {
                if (quest.questionID == action.payload.data.questionID)
                    foundndx = ndx
                else
                    ndx++
            })

            ndx = 0
            if (curtabs[state.tabndx].questions[foundndx].options) {
                curtabs[state.tabndx].questions[foundndx].options.forEach((option) => {
                    if (option.questionOptionID == action.payload.data.questionOptionID)
                        foundndx2 = ndx
                    else
                        ndx++
                })
            }
            else curtabs[state.tabndx].questions[foundndx]["options"] = []

            if (foundndx2 != -1)  
                curtabs[state.tabndx].questions[foundndx].options[foundndx2] = action.payload.data
            else 
                curtabs[state.tabndx].questions[foundndx].options.push(action.payload.data)

            curtabs[state.tabndx].questions[foundndx].options.sort((a, b) => {
                if (a.optionOrder > b.optionOrder)
                    return 1
                else if (a.optionOrder < b.optionOrder)
                    return -1
                else
                    return 0
            })

            return { ...state, updatingQuestions: false, updatedQuestions: true, tabs: curtabs }
        }

        case "FETCH_SCOPE_TAB_QUESTIONS_LIST_FULFILLED": {
            let ndx = 0
            let foundndx = -1
            let tabs = Object.assign([], state.tabs)

            tabs.forEach((tab) => {
                if (tab.projectTabId == state.tabid)
                    foundndx = ndx
                else ndx++
            })

            tabs[foundndx]["questions"] = action.payload.data
            tabs[foundndx]["numOptQuestions"] = action.payload.numOptQuestions

            return { ...state, updatingQuestions: false, updatedQuestions: true, tabs: tabs, tabndx: foundndx }
        }

        case "FETCH_SCOPE_TAB_QUESTIONS_ERROR": {
            return { ...state, errorQuestions: null }
        }

        // options
        case "DELETE_SCOPE_TAB_QUESTION_OPTION": {
            return { ...state, updatingQuestions: true, updatedQuestions: false, errorQuestions: null }
        }

        case "UPDATE_SCOPE_TAB_QUESTION_DETAIL_OPTIONS": {
            return { ...state, updatingQuestions: true, updatedQuestions: false, optionndx: action.payload.data }
        }

        case "UPDATE_SCOPE_TAB_QUESTION_DETAIL_OPTIONS_FULFILLED": {
            var curtabs = Object.assign([], state.tabs)

            curtabs[state.tabndx].questions[state.questionndx].options[state.optionndx] = action.payload.data
            curtabs[state.tabndx].questions[state.questionndx].options.sort((a, b) => {
                if (a.optionOrder > b.optionOrder)
                    return 1
                else if (a.optionOrder < b.optionOrder)
                    return -1
                else
                    return 0
            })

            return { ...state, updatingQuestions: false, updatedQuestions: true, tabs: curtabs }
        }

        case "DELETE_SCOPE_TAB_QUESTION_OPTION_REJECTED":
        case "FETCH_SCOPE_TAB_QUESTION_OPTIONS_REJECTED": {
            return { ...state, errorQuestions: action.payload }
        }

        case "FETCH_SCOPE_TAB_QUESTION_OPTIONS_FULFILLED": {
            let ndx = 0
            let foundquestionndx = -1
            let tabs = Object.assign([], state.tabs)

            tabs[state.tabndx]["questions"].forEach((question) => {
                if (action.payload.data.data.filter((option) => {
                    return option.questionID === question.questionID
                }).length) {
                    foundquestionndx = ndx
                }
                else ndx++
            })

            tabs[state.tabndx].rcvOptQuestions++

            if (foundquestionndx > -1) {
                tabs[state.tabndx]["questions"][foundquestionndx]["options"] = action.payload.data.data.sort((a, b) => {
                    if (a.optionOrder > b.optionOrder)
                        return 1
                    else if (a.optionOrder < b.optionOrder)
                        return -1
                    else
                        return 0
                })
            }
 
            return { ...state, tabs: tabs }
        }

        case "DELETE_SCOPE_TAB_QUESTION_OPTION_FULFILLED": {
            var ndx = 0
            var foundndx = -1
            var foundndx2 = -1

            var curtabs = Object.assign([], state.tabs)

            curtabs[state.tabndx].questions.forEach((quest) => {
                if (quest.questionID == action.payload.data.questionID)
                    foundndx = ndx
                else
                    ndx++
            })

            ndx = 0
            curtabs[state.tabndx].questions[foundndx].options.forEach((option) => {
                if (option.questionOptionID == action.payload.data.questionOptionID)
                    foundndx2 = ndx
                else
                    ndx++
            })

            curtabs[state.tabndx].questions[foundndx].options.splice(foundndx2, 1)
 
            return { ...state, updatingQuestions: false, updatedQuestions: true, tabs: curtabs }
        }

        default:
            return state
    }
}